import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E2E8F0] bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="text-mono-label">Trades Mechanical</div>
          <h3 className="font-display font-black text-3xl mt-3">Fixed right. Fixed once.</h3>
          <p className="text-[#475569] mt-4 max-w-md">Family-run appliance repair for Bronx, Westchester and Fairfield County. Same-week service, transparent pricing, no gimmicks.</p>
        </div>
        <div className="md:col-span-3">
          <div className="text-mono-label">Contact</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-brand" /> <a href="tel:+13478806834" className="link-hover">(347) 880-6834</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-brand" /> tradesmechanical@yahoo.com</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand" /> Bronx · Westchester · Fairfield</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-mono-label">Quick Links</div>
          <ul className="mt-4 space-y-2 text-sm text-[#475569]">
            <li><Link to="/services" className="link-hover">Services</Link></li>
            <li><Link to="/book" className="link-hover">Book an Appointment</Link></li>
            <li><Link to="/contact" className="link-hover">Contact</Link></li>
            <li><Link to="/login" className="link-hover">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-[#94A3B8]">
          <span className="font-mono">© {new Date().getFullYear()} TRADES MECHANICAL LLC</span>
          <span className="font-mono">LICENSED · INSURED · EPA-CERTIFIED</span>
        </div>
      </div>
    </footer>
  );
}
